import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../Helpers/API";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBack";
import UpdateIcon from "@mui/icons-material/Update";
import { AgruparByProp } from "../../../Helpers/Agrupaciones/AgruparByProp";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { TotalizarByProp } from "../../../Helpers/Agrupaciones/TotalizarByProp";
import ReporteDetalle from "./PDF/TotalCarteraDetallePDF";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";

//estilos para el boton de PDF
const styles = {
  pdfDownloadLink: {
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100px",
    height: "25px",
    borderRadius: "5px",
    marginLeft: "10px",
    marginRight: "10px",
    backgroundColor: "#940404",
    cursor: "pointer",
    boxShadow: "3px 3px 3px #333",
    color: "rgba(255, 255, 255, 0.8)",
  },
};

export const TotalCarteraDetalle = () => {
  const location = useLocation();
  const history = useHistory();
  const [state, setState] = useState({
    data: [],
    lineas: [],
    estado: [],
  });
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  useEffect(() => {
    Actualizar();
  }, []);
  const onHome = () => {
    history.push("/Creditoycobranza/TotalCarteraPorLinea", {
      idsucursal: location.state.idsucursal,
    });
  };

  const Actualizar = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `TotalCarteraDetalle/Listado?idsucursal=${Number(
          location.state.idsucursal
        )}&linea=${location.state.linea}`
      )
      .then((result) => {
        setState({
          data: result,
          lineas: AgruparByProp(result, "departamento"),
        });
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("TOTAL CARTERA", JSON.stringify(error), "error");
      });
  };
  const onGeneraExcel = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `TotalCarteraDetalle/GenerarExcel?idsucursal=${Number(
          location.state.idsucursal
        )}&linea=${location.state.linea}`
      )
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const onSiguiente = (cliente, razonsocial) => {
    history.push(
      "/Creditoycobranza/TotalCarteraDetalleCliente",
      {
        cliente,
        razonsocial,
        idsucursal: location.state.idsucursal,
        linea: location.state.linea,
      }
    );
  };

  const PDFDownloadButton = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`TotalCarteraDetalle/ReporteDetallePDF?idsucursal=${Number(
        location.state.idsucursal
      )}&linea=${location.state.linea}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  // return <></>
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  }; 

  return (
    <div className="total-cartera-detlle">
      <LoaderScreen loader={loader} />
      <header id="header">
        <div className="title">
          <div className="btn-cobranza-regresar" onClick={() => onHome()}>
            <ArrowBackIosIcon /> Regresar
          </div>
          {/* CARTERA DETALLE ASSas {JSON.stringify(location.state)} */}
          RESUMEN DE CARTERA{" "}
          {Number(location.state.idsucursal) !== 0 &&
            " DE " + location.state.sucursal}{" "}
          POR CLIENTES DE{" "}
          {location.state.linea === "MAQ. NUEVA"
            ? "MAQUINARIA"
            : location.state.linea} 
        </div>
        <div className="buttons">
          <button onClick={() => Actualizar()} className="actualizar">
            <UpdateIcon /> Actualizar
          </button>
          <button className="excel" onClick={() => onGeneraExcel()}>
            <i className=" icon-file-excel" /> Excel
          </button>
          <button className="PDF" onClick={() => PDFDownloadButton()} style={{backgroundColor:'#940404'}}>
            PDF
          </button>
        </div>
      </header>
      <div className="container-data-total-cartera scroll">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              {Number(location.state.idsucursal) == 0 && <th> SUCURSAL</th>}
              <th>
                {Number(location.state.idsucursal) === 0 ? (
                  <div>Id Cliente</div>
                ) : (
                  "Id Cliente"
                )}
              </th>
              <th>
                <div>Razón Social</div>
              </th>
              <th>
                <div>Total Cartera</div>
              </th>
              <th>
                <div>Saldo a Favor</div>
              </th>
              <th>
                <div>Total</div>
              </th>
              <th>
                <div>Jurídico</div>
              </th>
              <th>%</th>
              <th>
                <div>Cartera Activa</div>
              </th>
              <th>%</th>
              <th>
                <div>Por Vencer</div>
              </th>
              <th>%</th>
              <th>
                <div>Vencida</div>
              </th>
              <th>%</th>
              <th>
                <div>De 1 a 15</div>
              </th>
              <th>%</th>
              <th>
                <div>Más de 15</div>
              </th>
              <th>%</th>
              <th>
                <div>Más de 30</div>
              </th>
              <th>%</th>
              <th>
                <div>Más de 60</div>
              </th>
              <th>%</th>
              <th>
                <div>Más de 90</div>
              </th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            {state.data.map((x) => (
              <tr
                className="row-detalle"
                onClick={() => onSiguiente(x.idcliente, x.razonsocial)}
              >
                {x.departamento === "TOTAL" ? (
                  <td colSpan={Number(location.state.idsucursal) == 0 ? 3 : 2}>
                    TOTAL
                  </td>
                ) : (
                  <>
                    {Number(location.state.idsucursal) == 0 && (
                      <td>{x.sucursal}</td>
                    )}

                    <td className="idcliente">{x.idcliente}</td>
                    <td className="razon-social"> {capitalizeWords(x.razonsocial)}</td>
                  </>
                )}

                <td>{FormatMoney(x.totalcartera)}</td>
                <td>{FormatMoney(x.saldoafavor)}</td>
                <td>{FormatMoney(x.total)}</td>
                <td>{FormatMoney(x.juridico)}</td>
                <td className="porcentaje">
                  {FormatMoney(
                    (x.juridico / (x.totalcartera)) * 100
                  )}
                </td>
                <td>{FormatMoney(x.activo)}</td>
                <td className="porcentaje">
                  {FormatMoney(
                    (x.activo / (x.totalcartera )) * 100
                  )}
                </td>
                <td>{FormatMoney(x.porvencer)}</td>
                <td className="porcentaje">
                  {FormatMoney(
                    (x.porvencer / (x.totalcartera)) * 100
                  )}
                </td>
                <td>{FormatMoney(x.vencido)}</td>
                <td className="porcentaje">
                  {FormatMoney(
                    (x.vencido / (x.totalcartera)) * 100
                  )}
                </td>
                <td>{FormatMoney(x.de1a15)}</td>
                <td className="porcentaje">{FormatMoney((x.de1a15 / x.vencido) * 100)}</td>
                <td>{FormatMoney(x.mas15)}</td>
                <td className="porcentaje">{FormatMoney((x.mas15 / x.vencido) * 100)}</td>
                <td>{FormatMoney(x.mas30)}</td>
                <td className="porcentaje">{FormatMoney((x.mas30 / x.vencido) * 100)}</td>
                <td>{FormatMoney(x.mas60)}</td>
                <td className="porcentaje">{FormatMoney((x.mas60 / x.vencido) * 100)}</td>
                <td>{FormatMoney(x.mas90)}</td>
                <td className="porcentaje">{FormatMoney((x.mas90 / x.vencido) * 100)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
